var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "premium-personal-account-cell",
      class: { "premium-personal-account-cell_disabled": !_vm.canEdit },
      on: {
        click: function ($event) {
          _vm.canEdit && (_vm.isShowPersonalAccountInfoModal = true)
        },
      },
    },
    [
      _c(
        "c-sidesheet",
        {
          staticClass: "premium-personal-account-cell-sidesheet",
          attrs: { active: _vm.isShowPersonalAccountInfoModal },
          on: { close: _vm.closePersonalAccountInfoModal },
        },
        [
          _c(
            "svg",
            {
              staticClass: "premium-personal-account-cell-sidesheet-close",
              attrs: {
                width: "15",
                height: "16",
                viewBox: "0 0 15 16",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
              on: { click: _vm.closePersonalAccountInfoModal },
            },
            [
              _c("path", {
                attrs: {
                  d: "M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z",
                  fill: "#8E9CBB",
                },
              }),
              _c("path", {
                attrs: {
                  d: "M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z",
                  fill: "#8E9CBB",
                },
              }),
            ]
          ),
          _c(
            "div",
            { staticClass: "premium-personal-account-cell-title" },
            [
              _c(
                "div",
                { staticClass: "premium-personal-account-cell-title-desc" },
                [_vm._v("Личный счет")]
              ),
              _c(
                "router-link",
                {
                  staticClass: "premium-personal-account-cell-title-link",
                  attrs: {
                    target: "_blank",
                    to: {
                      name: "personal-employee-summary",
                      params: { id: _vm.record.id },
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.record.employee.value) + " ")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "premium-personal-account-cell-sidesheet-table" },
            [
              _vm.isDataLoading
                ? _c(
                    "div",
                    {
                      staticClass:
                        "premium-personal-account-cell-sidesheet-table-loader",
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: _vm.icon, spin: "" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.isDataLoading
                ? _c("c-table-data-personal-transactions", {
                    ref: "table",
                    staticClass:
                      "premium-personal-account-cell-sidesheet-table-table",
                    attrs: {
                      "empty-records-label": "Записи не найдены",
                      levels: 1,
                      "disabled-columns": _vm.tableData.disabledColumns,
                      data: _vm.tableData,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "premium-personal-account-cell-value" },
        [
          _c("c-button", {
            directives: [
              {
                name: "b-popover",
                rawName: "v-b-popover.html",
                value: {
                  container: "#app",
                  trigger: "hover blur",
                  content: "История личного счета сотрудника",
                  placement: "top",
                },
                expression:
                  "{\n        container: '#app',\n        trigger: 'hover blur',\n        content: 'История личного счета сотрудника',\n        placement: 'top',\n      }",
                modifiers: { html: true },
              },
            ],
            staticClass: "premium-personal-account-cell-value-button",
            attrs: { size: "iconic", icon: "menu" },
          }),
          _vm._v(" " + _vm._s(_vm.record.premium_personal_account.value) + " "),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }